import { LocalDate } from '@js-joda/core';

import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';
import { EmailAddress } from '@dreryk/email-address-common-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';
import { Country, Postcode } from '@dreryk/address-common-api';
import {
   GuardianPesel,
   NationalIdentificationNumberCountry,
   Pesel,
} from '@dreryk/personal-external-identifier-common-api';

import { FormContextValues } from '@dreryk/react-common';

import { IdentityDocumentFormPart } from '../identityDocument/IdentityDocumentFormSection';

import { GuardianModalFormBean } from './GuardianModal/GuardianModal.types';
import { PatientSelectIdentifierType } from './PersonForm/PatientIdentifierTypeField/PatientIdentifierTypeField';
import { GenderSelectItem } from './PersonForm/Gender/GenderField.hooks';

export type PersonalDataFormBean = {
   firstName: string | null;
   middleName: string | null;
   lastName: string | null;
   country: Country;
   town: string | null;
   postcode: Postcode | null;
   street: string | null;
   house: string | null;
   flat: string | null;
   phoneNumber: PhoneNumber | null;
   emailAddress: EmailAddress | null;
   nfzDepartment: NfzDepartment | null;
   personalIdentifierType: PatientSelectIdentifierType;
   birthDate: LocalDate | null;
   gender: GenderSelectItem | null;
   pesel?: Pesel | null;
   guardianPesel?: GuardianPesel | null;
   identifyingGuardian?: GuardianModalFormBean;
   passport?: string | null;
   passportCountry?: Country | null;
   passportValidTo?: LocalDate | null;
   nationalIdentificationNumber?: string | null;
   nationalIdentificationNumberCountry?: NationalIdentificationNumberCountry | null;
   medicalRecordNumber?: string | null;
   identityDocument: IdentityDocumentFormPart;
};

export enum PersonalIdentifierType {
   PESEL = 'PESEL',
   GUARDIAN_PESEL = 'GUARDIAN_PESEL',
   PASSPORT = 'PASSPORT',
   NATIONAL_IDENTIFICATION_NUMBER = 'NATIONAL_IDENTIFICATION_NUMBER',
   MEDICAL_RECORD_NUMBER = 'MEDICAL_RECORD_NUMBER',
}

export enum PatientPanelNavParams {
   PERSONAL_DATA = 'dane-osobowe',
   PATIENT_GROUPS = 'oznaczenia-pacjenta',
   MEDICAL_INFORMATION = 'dane-medyczne',
   VISITS_HISTORY = 'historia-wizyt',
   PRESCRIPTIONS_HISTORY = 'historia-recept',
   MEDICAL_DOCUMENT_REPOSITORY = 'repozytorium',
   CONSENTS_AND_AUTHORIZATION = 'zgody-i-upowaznienia',
}

export type PersonalDataFormController = FormContextValues<PersonalDataFormBean>;

export type PatientFileLocationData = {
   showAppointmentOutOfSchedule: boolean;
   appointmentId?: number;
};
